module.exports = __webpack_public_path__ + "img/car_sendai09.63118d09.jpg";